import * as React from "react";
export function SvgSchemaViewerNumericBin(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={17} {...props}>
      <path
        d="M17.8 13h-.3c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h.3c.3 0 .5.2.5.5v1c0 .3-.3.5-.5.5zM14.8 13h-.3c-.3 0-.5-.2-.5-.5v-5c0-.3.2-.5.5-.5h.3c.3 0 .5.2.5.5v5c0 .3-.3.5-.5.5zM11.8 13h-.3c-.3 0-.5-.2-.5-.5v-8c0-.3.2-.5.5-.5h.3c.3 0 .5.2.5.5v8c0 .3-.3.5-.5.5zM8.8 13h-.3c-.3 0-.5-.2-.5-.5v-5c0-.3.2-.5.5-.5h.3c.2 0 .5.2.5.5v5c0 .3-.3.5-.5.5zM5.8 13h-.3c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h.3c.3 0 .5.2.5.5v1c0 .3-.3.5-.5.5z"
        fill="#367e9c"
      />
    </svg>
  );
}
